export enum SettingsQueries {
	GET_USER_PROFILE_ROLES = `
    query UserProfileRoles ($where: UserProfileRoleFilterInput, $first: Int, $after: String) {
        userProfileRoles(
            where: $where,
            first: $first,
            after: $after
        ) {
            nodes {
            id
            role {
                id
                name
            }
            userProfile {
                id
                name
                companyId
                platformId
                }
            }
            totalCount
        }
    }
    `,
    GET_ROLES = `
    query Roles ($where: RoleFilterInput, $first: Int, $after: String) {
        roles(
            where: $where,
            first: $first,
            after: $after
        ) {
            totalCount
            nodes {
                id
                name
            }
        }
    }
    `,
    GET_USER_PROFILES = `
    query UserProfiles ($where: UserProfileFilterInput, $first: Int, $after: String) {
        userProfiles(
            where: $where,
            first: $first,
            after: $after
        ) {
            totalCount
            nodes {
                id
                name
            }
        }
    }
    `,
}
